import { render, staticRenderFns } from "./LogoBlack.vue?vue&type=template&id=80317378&scoped=true&"
import script from "./LogoBlack.vue?vue&type=script&lang=js&"
export * from "./LogoBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80317378",
  null
  
)

export default component.exports